<header class="header">
    <nav class="nav">
        <!-- Logo -->
        <a routerLink="/" class="nav__logo">
            <img src="assets/img/corvusIcon.ico" alt="Corvus TID" class="nav__logo-img">
            
        </a>

        <div class="nav__menu" [ngClass]="showMenu ? 'show-menu ':'hide-menu'">
            <ul class="nav__list grid">
                <li class="nav__item" *ngFor="let item of itemsMenu">
                    <a [routerLink]="['/' + item.ruta]" 
                       routerLinkActive="active" 
                       class="nav__link"
                       (click)="closeMenu()">
                        <i class="{{item.icono}} nav__icon"></i>
                        {{item.nombre}}
                    </a>
                </li>
            </ul>
            <i class="fas fa-times nav__close" (click)="openAndCloseMenu()"></i>
        </div>
        <div class="nav__btns">
            <!-- Toggle de modo de color -->
            <!-- <button class="color-mode-toggle" 
                    (click)="toggleColorMode()" 
                    title="Cambiar modo de color">
                <i class="{{isMonochromeMode ? 'fas fa-palette' : 'fas fa-adjust'}}"></i>
            </button> -->
            
            <div class="nav__toggle" (click)="openAndCloseMenu()">
                <i class="fas fa-bars"></i>
            </div>
        </div>
    </nav>
</header>